import React from 'react';
import styled from 'styled-components/native';
import SkeletonPlaceholder from '../skeletonPlaceholder';
import {getByScreenSize} from '../../utils/responsive';
import {useTheme} from 'styled-components';
import {Theme} from '../../theme/lightTheme';

const Container = styled.View`
  width: 100%;
  align-items: center;
`;
const Row = styled.View`
  width: 100%;
  margin-bottom: 2%;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

const DrugFiltersListSkeleton = () => {
  const theme = useTheme() as Theme;
  return (
    <Container>
      {[0, 1, 2, 3, 4].map(item => (
        <Row key={item}>
          <SkeletonPlaceholder
            width={'49%'}
            height={theme.text.s8 * 4}
            borderRadius={4}
          />
          <SkeletonPlaceholder
            width={'49%'}
            height={theme.text.s8 * 4}
            borderRadius={4}
          />
        </Row>
      ))}
    </Container>
  );
};

export default DrugFiltersListSkeleton;
